import axios from "axios";
import { getMainDomain } from "./getMainDomain";
import { domainConfig } from "@/constants/domain.config";
import { jotaiStore } from "@/atoms/store";
import { dataSourceAtom } from "@/atoms/app";
function getBaseURL() {
  const { domain } = useSubdomain();
  if (isDevEnv) {
    return import.meta.env.VITE_API_NEWS_PROXY;
  } else if (getMainDomain() === "mobi321.com" || domain === "wx.mobi321.com") {
    return domainConfig["mobi321.com"];
  } else if (getMainDomain() === "24hweather.com") {
    return domainConfig["24hweather.com"];
  } else if (window.location.hostname === "test.comfortweather.com") {
    return domainConfig["test.comfortweather.com"];
  } else if (window.location.hostname === "test1.comfortweather.com") {
    return domainConfig["test1.comfortweather.com"];
  } else {
    return domainConfig["default"];
  }
}
const axiosConfig = {
  baseURL: getBaseURL(),
  timeout: 5 * 60 * 1000,
  headers: { "Content-Type": "application/json" },
};
const instance = axios.create(axiosConfig);
instance.interceptors.request.use(
  (config: any) => {
    return config;
  },
  error => Promise.reject(error),
);

instance.interceptors.response.use(
  (response: any) => {
    const resData = response.data;
    // 临时测试 把wni标识显示在页面
    if (resData?.data?.f) {
      jotaiStore.set(dataSourceAtom, resData.data.f);
    }
    if (!isDevEnv) {
      trackApiFetch(response.config.url);
    }
    return resData;
  },
  error => Promise.reject(error),
);

const trackApiFetch = (apiUrl: string) => {
  gtag("event", "fetchApi", { api: apiUrl });
};

export default instance;
